export function getInitials(
  isAdmin: boolean,
  isVirtualAdmin: boolean,
  isGuest: boolean,
  firstName?: string | null,
  lastName?: string | null,
): string {
  const initials = [firstName, lastName]
    .filter(Boolean)
    .map((value) => value![0])
    .join("");
  if (initials) {
    return initials.toUpperCase();
  }
  if (isGuest) return "G";
  if (isVirtualAdmin) return "VA";
  if (isAdmin) return "A";
  return "U";
}
